import './ViewMoreFooter.css'

export default function ViewMoreFooter () {
  // return <div class='ViewMoreFooter'>ViewMoreFooter</div>
  return <div class='ViewMoreFooter'></div>
}
